/* @flow */
import CurrentUser from 'auth/CurrentUser';
import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

type ReplaceFn = (location: LocationDescriptor) => void;
type RedirectFn = (nextState: RouterState, replaceWith: ReplaceFn) => void;

export default function requireFeaturesOnEnter(
  permissions: string[],
  redirect?: RedirectFn
): RedirectFn {
  return (nextState: RouterState, replaceWith: (location: LocationDescriptor) => void) => {
    const user = CurrentUser.isSignedIn() ? CurrentUser.getUser() : null;
    if (!user) {
      replaceWith('/error');
      return;
    }

    if (!permissions.every(permission => user.hasFeature(permission))) {
      if (!redirect) {
        replaceWith('/error');
      } else {
        redirect(nextState, replaceWith);
      }
    }
  };
}
